import i18next from 'i18next';
import { array, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        country: string().required(REQUIRED_TEXT).nullable(),
        name: string().required(REQUIRED_TEXT).nullable(),
        products: array()
            .of(
                object().shape({
                    item: string().required(REQUIRED_TEXT).nullable(),
                }),
            )
            .min(1, i18next.t('At least one product is required'))
            .required(REQUIRED_TEXT),
        template_bom: string().required(REQUIRED_TEXT).nullable(),
        type_application: string().required(REQUIRED_TEXT).nullable(),
    });
};
